module.exports = __webpack_public_path__ + "img/AX.df87250f.svg";